const STOPWORDS = new Set([
  'a',
  'an',
  'and',
  'any',
  'are',
  'as',
  'at',
  'be',
  'by',
  'can',
  'could',
  'do',
  'does',
  'doing',
  'done',
  'for',
  'from',
  'get',
  'got',
  'has',
  'have',
  'help',
  'how',
  'i',
  'in',
  'is',
  'it',
  'its',
  'just',
  'like',
  'looking',
  'me',
  'my',
  'need',
  'needs',
  'of',
  'on',
  'or',
  'our',
  'out',
  'please',
  'should',
  'so',
  'some',
  'something',
  'that',
  'the',
  'their',
  'them',
  'there',
  'this',
  'to',
  'try',
  'up',
  'us',
  'use',
  'using',
  'want',
  'wants',
  'we',
  'what',
  'when',
  'where',
  'which',
  'will',
  'with',
  'would',
  'you',
  'your',
]);

function stem(word: string): string {
  if (word.length <= 3) return word;
  if (word.endsWith('ies') && word.length > 4) return word.slice(0, -3) + 'y';
  if (word.endsWith('es') && word.length > 4) return word.slice(0, -2);
  if (word.endsWith('ing') && word.length > 5) return word.slice(0, -3);
  if (word.endsWith('ed') && word.length > 4) return word.slice(0, -2);
  if (word.endsWith('s') && !word.endsWith('ss')) return word.slice(0, -1);
  return word;
}

function tokenize(text: string): string[] {
  return text
    .toLowerCase()
    .split(/[^a-z0-9]+/)
    .filter(Boolean)
    .map(stem);
}

function queryWords(query: string): string[] {
  return query
    .toLowerCase()
    .split(/[^a-z0-9]+/)
    .filter((w) => w && !STOPWORDS.has(w))
    .map(stem);
}

/**
 * Filter items to those with score > 0 against `query`.
 * Returns all items when query is empty or contains only stopwords.
 * Order is preserved.
 */
export function filterByQuery<T extends { title: string; description: string | null }>(
  items: T[],
  query: string,
): T[] {
  const words = queryWords(query);
  if (words.length === 0) return items;
  return items.filter((item) => {
    const titleTokens = tokenize(item.title);
    const descTokens = tokenize(item.description ?? '');
    return words.some(
      (w) =>
        titleTokens.some((t) => t === w || t.startsWith(w)) ||
        descTokens.some((t) => t === w || t.startsWith(w)),
    );
  });
}
